<script setup lang="ts">
import { mdiHome, mdiRefresh } from '@quasar/extras/mdi-v7';

// UI only: props in, events out. The parent view resolves copy + which actions to
// show from the parsed backend error (see joinErrorPresentation).
interface Props {
  icon: string;
  title: string;
  message: string;
  showRetry?: boolean;
}

withDefaults(defineProps<Props>(), {
  showRetry: false,
});

defineEmits<{
  home: [];
  retry: [];
}>();
</script>

<template>
  <div class="school-join-error flex flex-center">
    <q-card
      flat
      bordered
      class="school-join-error__card q-pa-lg text-center"
    >
      <div class="school-join-error__icon flex flex-center q-mx-auto q-mb-md">
        <q-icon
          :name="icon"
          size="48px"
          color="negative"
        />
      </div>

      <div class="text-h6 text-weight-bold q-mb-sm">
        {{ title }}
      </div>

      <div class="text-body1 text-grey-8 q-mb-lg">
        {{ message }}
      </div>

      <div class="column q-gutter-sm items-stretch">
        <q-btn
          v-if="showRetry"
          unelevated
          color="primary"
          :icon="mdiRefresh"
          :label="$t('SCHOOL_JOIN_RETRY')"
          @click="$emit('retry')"
        />
        <q-btn
          :flat="!showRetry"
          :outline="showRetry"
          color="primary"
          :icon="mdiHome"
          :label="$t('SCHOOL_JOIN_GO_HOME')"
          @click="$emit('home')"
        />
      </div>
    </q-card>
  </div>
</template>

<style lang="scss" scoped>
.school-join-error {
  min-height: 60vh;

  &__card {
    width: 100%;
    max-width: 26rem;
    border-radius: 1rem;
  }

  &__icon {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background: rgba(193, 0, 21, 0.1);
  }
}
</style>
